import React from "react";

import ToggleLinks from "../../../parts/inputs/toggle-links-input";

const AdminToggle = () => {
  return (
    <div className="Admin-Toggle">
      <ToggleLinks
        name="admin-toggle"
        options={[
          { text: "Users", value: "users", href: "/admin/users" },
          { text: "Reports", value: "reports", href: "/admin/reports" },
          {
            text: "Exercise Library",
            value: "exercise-library",
            href: "/admin/exercise-library",
          },
          {
            text: "MSB University",
            value: "tutorial-categories",
            href: "/admin/tutorials",
          },
        ]}
      />
    </div>
  );
};

export default AdminToggle;
